import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
import { ClienteVinculo } from "./../../model/cliente/clientevinculo.model";
import { PermissoesService } from "./../../service/usuario/permissoes.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatSort, MatTableDataSource, MatPaginator } from "@angular/material";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";

@Component({
  selector: "app-vincular-empresa-dialog",
  templateUrl: "./vincular-empresa-dialog.component.html",
  styleUrls: ["./vincular-empresa-dialog.component.scss"],
})
export class VincularEmpresaDialogComponent implements OnInit {
  orderForm: FormGroup;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayName;
  public loading = false;
  displayedColumns = ["vinculado", "cpf", "nome", "nomeFantasia"];
  dataSource: MatTableDataSource<ClienteVinculo>;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  marcados = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VincularEmpresaDialogComponent>,
    private permissaoService: PermissoesService,
    private _snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) {
    this.displayName = this.data.dataDialog.displayName;
    permissaoService
      .getEmpresasVinculadas(this.data.dataDialog.id)
      .subscribe((data) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        data.map((item) => {
          if (item.vinculado) {
            this.marcados.push(item.id);
          }
        });
      });
  }

  ngOnInit() {
    this.orderForm = this.formBuilder.group({
      user: this.data.dataDialog,
      empresas: [],
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  rowClicked(row: any): void {
    console.log(row);
    console.log(this.dataSource);
  }

  unique(a) {
    return a.reduce(function (p, c) {
      if (p.indexOf(c) < 0) p.push(c);
      return p;
    }, []);
  }

  changeCheck(e) {
    let check = e.target.checked;
    if (check) {
      if (this.marcados.indexOf(Number(e.target.value)) < 0) {
        this.marcados.push(Number(e.target.value));
      }
    } else {
      if (this.marcados.indexOf(Number(e.target.value)) >= 0) {
        this.marcados.splice(this.marcados.indexOf(Number(e.target.value)), 1);
      }
    }
  }

  salvar() {
    this.loading = true;
    //this.marcados = [];
    let filtros = [];
    // this.dataSource.filteredData.forEach((element) => {
    //   if (element.vinculado) {
    //     this.marcados.push(element.id);
    //   }
    // });
    this.orderForm.get("empresas").setValue(this.marcados);
    var concatenado = this.unique( this.marcados.concat( filtros ) );
    this.permissaoService.postVinculoEmpresa(this.orderForm.value).subscribe(
      (data) => {
        this.openSnackBarSuccess("Salvo com sucesso !");
        this.loading = false;
        this.dialogRef.close();
      },
      (err) => {
        this.openSnackBarError("Erro ao vincular empresa !");
        this.loading = false;
      }
    );
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/vincular-empresa-dialog/vincular-empresa-dialog.component.ts